module.exports = __webpack_public_path__ + "img/audit.20a7c7bd.png";